const LOAD_INITIAL = 'intl/LOAD_INITIAL';

export default {
  LOAD_INITIAL
};
